module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'TransferTypeList'
      }
    }
  }, [_vm._v("Typy przelewów")])], 1), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'TransferTypeCreate'
      }
    }
  }, [_c('span', [_vm._v("Dodaj typ przelewu")]), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th', [_vm._v("Cena")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'TransferTypeShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['name']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'TransferTypeShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['amount']) + " PLN")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'TransferTypeUpdate',
          params: {
            id: item['id']
          }
        },
        "title": "Edytuj"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1)], 1)])
  }), 0)])])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9607194","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transfertype/List.vue
// module id = 837
// module chunks = 0